/* Include announcement bars and the theme header in the full-screen budget. */
if (!customElements.get('hero-banner')) {
  customElements.define('hero-banner', class extends HTMLElement {
    connectedCallback() {
      this.updateHeight = () => {
        const headers = [...document.querySelectorAll('.shopify-section-group-header-group')];
        const height = headers.reduce((total, header) => total + header.getBoundingClientRect().height, 0);
        if (headers.length) this.style.setProperty('--hero-banner-header-height', `${height}px`);
      };
      this.headerObserver = new ResizeObserver(this.updateHeight);
      document.querySelectorAll('.shopify-section-group-header-group').forEach(header => this.headerObserver.observe(header));
      window.addEventListener('resize', this.updateHeight);
      this.updateHeight();
      this.smoothScroll = event => {
        const link = event.target.closest('.hero-banner__button');
        if (!link || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
        const url = new URL(link.href, location.href);
        if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search || !url.hash) return;
        let target;
        try { target = document.getElementById(decodeURIComponent(url.hash.slice(1))); } catch { return; }
        if (!target) return;
        event.preventDefault();
        const headerHeight = parseFloat(getComputedStyle(this).getPropertyValue('--hero-banner-header-height')) || 0;
        window.scrollTo({
          top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - headerHeight - 16),
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      };
      this.addEventListener('click', this.smoothScroll);

    }
    disconnectedCallback() {
      this.removeEventListener('click', this.smoothScroll);
      this.headerObserver?.disconnect();
      window.removeEventListener('resize', this.updateHeight);
    }
  });
}
